import gql from 'graphql-tag';

export const CREATE_IMAGE_CROP = gql`
    mutation createImageCrop($input: CreateImageCropInput) {
        createImageCrop(input: $input)
    }
`;
